export default {"src":"/_next/static/media/creditScore.67297f2d.svg","height":83,"width":157};